/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-23 19:04:30 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2020-04-14 00:46:07
 */

import React from "react"
import PropTypes from "prop-types"
import { connect, useDispatch, useSelector } from "react-redux"
import { useLocation, withRouter } from 'react-router-dom'
import { bindActionCreators } from "redux"
import AppBar from "material-ui/AppBar"
import { Toolbar } from "material-ui"
import Typography from "material-ui/Typography"
import Button from "material-ui/Button"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom";

import model from '../../../model'
import auth from '../../auth'
import Container from "./Container"
import Separator from "./Separator"
import ChangePasswordPopUp from "modules/auth/change-password/ChangePasswordPopUp"
import ChangePhonePopUp from "modules/auth/change-phone/ChangePhonePopUp"
import { CSSTransition } from "react-transition-group"

import '../layout.css'

const LinkButton = ({path, name}) => {
  const history = useHistory();
  const location = useLocation()

  const linkHandler = () => {
    history.push(path)
  } 
  
  return (
    <Button 
      className={location.pathname === path ? "active" : null}
      onClick={linkHandler}
      style={{textTransform: "none"}}
    >
      {name}
    </Button>
  )
}

const TopNav = () => {
  const history = useHistory();
  const dispatch = useDispatch()
  const authUser = useSelector(state => state.auth.profile)
  const isAdmin = useSelector(state => state.auth.profile?.isAdmin)
  const showPopUp = useSelector(state => state.auth.showChangeEmailPopUp)
  const showChangePhonePopUp = useSelector(state => state.auth.showChangePhonePopUp)
  
  const logout = () => {
    history.push("/")
    localStorage.removeItem("token")
    dispatch(auth.actions.logout())
  }

  const showPopUpHandler = () => dispatch(auth.actions.showPopUp()) 
  const showPhonePopUpHandler = () => dispatch(auth.actions.showChangePhonePopUp()) 
  
  return (
    <AppBar color={"default"} position={"sticky"} className="layout__toolbar">
      <Toolbar>
        <Container className="flex">
        {
            isAdmin &&
              <LinkButton
                name="Admin Homepage"
                path="/admin"
              />
          }

          {
            authUser &&
              <LinkButton
                name={isAdmin ? "Invoicing Management" : "Receipt Management"}
                path="/"
              />
          }

          {
            isAdmin &&
              <LinkButton
                name="Counsellor Pay"
                path="/counsellors"
              />
          }

          <Separator />
          {
            authUser &&
            <div className="settings-btns">
              <p className="settings-btn">Settings</p>
              <Button onClick={showPopUpHandler}>Change password</Button>
              { 
                !isAdmin && 
                  <Button onClick={showPhonePopUpHandler}>Change phone</Button>
              }
              <Button onClick={logout}>Logout</Button>
            </div>
          }
          
         
          {
            authUser && 
              <Typography
                component={'span'} 
                key={'topNav-1'}
                className="welcome-message"
              >
                Welcome {authUser?.name}
              </Typography>
          }
          
          <CSSTransition
              in={showPopUp}
              timeout={500}
              classNames="alert"
              unmountOnExit
            >
              <ChangePasswordPopUp/>
          </CSSTransition>

          <CSSTransition
            in={showChangePhonePopUp}
            timeout={500}
            classNames="alert"
            unmountOnExit
          >
            <ChangePhonePopUp/>
          </CSSTransition>
        </Container>
      </Toolbar>
    </AppBar>
  )
}

export default withRouter(TopNav)